(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/draw.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/draw.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.Draw = Backbone.Model.extend({
    initialize: function() {
      this.set('isCurrentDraw', false);
      var activatedDrawId = svs.utils.url.queryString.activatedDrawId,
        drawUrlAddOn = this.get('productId').toString() + '_' + this.get('drawNumber');
      if (activatedDrawId) drawUrlAddOn = drawUrlAddOn + '_' + activatedDrawId;
      this.set(
        'urlAddOn',
        drawUrlAddOn
      );
    },

    setJackpotData: function(jackpotData) {
      this.set('currentJackpot', jackpotData.get('currentJackpot'));
      this.set(
        'currentJackpotFormatted',
        jackpotData.get('currentJackpotFormatted')
      );
      this.set(
        'currentJackpotInMillions',
        jackpotData.get('currentJackpotInMillions')
      );
    },

    getIsOpen: function() {
      return this.get('drawStateId') == svs.tipset.constants.DRAW_STATE_OPEN;
    }
  });
})(Backbone, _, svs);

 })(window);